
import { Options, Vue } from 'vue-property-decorator'

@Options({
  name: 'Search'
})
export default class Search extends Vue {}
